import React, { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../../components/api/ApiClient';
import CompanyEditModal from './CompanyEditModal';
import MoadianFilesModal from './MoadianFilesModal';
import ProfileBranches from './ProfileBranches';

function ProfileCreate() {
    const [companyData, setCompanyData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showMoadianModal, setShowMoadianModal] = useState(false);

    const fetchCompanyData = useCallback(async () => {
        try {
            const response = await apiClient('/companies/api/');
            if (response.companies && response.companies.length > 0) {
                setCompanyData(response.companies[0]);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchCompanyData();
    }, [fetchCompanyData]);

    const handleEditSave = () => {
        fetchCompanyData();
    };

    // if (loading) return ... (Keep loading if you want, but user wants to see UI. Actually user said "when it brings corporate info not found", which implies loading finished).
    // Let's keep loading for now as it wasn't the complaint.
    if (loading) return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-12">
                    <div className="card stretch">
                        <div className="card-body text-center p-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="mt-3">در حال بارگذاری اطلاعات بنگاه...</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const safeCompanyData = companyData || {};

    const getPersonType = (type) => {
        switch (type) {
            case 1: return 'حقیقی';
            case 2: return 'حقوقی';
            case 3: return 'مشارکت مدنی';
            case 4: return 'اتباع غیر ایرانی';
            default: return 'نامشخص';
        }
    };

    return (
        <div className="container-fluid">
            {error && (
                <div className="alert alert-danger mx-4 mt-4">
                    خطا در بارگذاری اطلاعات: {error}
                </div>
            )}
            {!companyData && !error && (
                <div className="alert alert-warning mx-4 mt-4">
                    اطلاعات بنگاهی یافت نشد. لطفاً اطلاعات بنگاه را ثبت کنید.
                </div>
            )}
            <div className="row">
                <div className="col-xl-12">
                    <div className="card border-0 shadow-sm stretch">
                        <div className="card-header bg-transparent border-bottom-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                            <h5 className="fw-bold mb-0">مشخصات بنگاه اقتصادی</h5>
                            <div className="d-flex gap-2">
                                <button
                                    className="btn btn-primary"
                                    onClick={() => setShowEditModal(true)}
                                >
                                    <i className="feather-edit me-1"></i>
                                    {companyData ? 'ویرایش بنگاه اقتصادی' : 'ثبت بنگاه اقتصادی'}
                                </button>
                                <button
                                    className="btn btn-success"
                                    onClick={() => setShowMoadianModal(true)}
                                >
                                    <i className="feather-file-text me-1"></i>
                                    تولید فایل درخواست گواهی
                                </button>
                            </div>
                        </div>
                        <div className="card-body p-4">
                            <div className="row g-4 text-start" dir="rtl">
                                <div className="col-lg-4 col-md-6">
                                    <label className="form-label fw-bold text-muted fs-12 mb-1">نام شرکت/شخص</label>
                                    <div className="fs-14 fw-bold text-dark p-2 bg-gray-50 rounded">{safeCompanyData.name || '-'}</div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <label className="form-label fw-bold text-muted fs-12 mb-1">نوع شخص</label>
                                    <div className="fs-14 fw-bold text-dark p-2 bg-gray-50 rounded">{getPersonType(safeCompanyData.personType)}</div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <label className="form-label fw-bold text-muted fs-12 mb-1">شناسه ملی/کد ملی</label>
                                    <div className="fs-14 fw-bold text-dark p-2 bg-gray-50 rounded">{safeCompanyData.nationalCode || '-'}</div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <label className="form-label fw-bold text-muted fs-12 mb-1">کد اقتصادی</label>
                                    <div className="fs-14 fw-bold text-dark p-2 bg-gray-50 rounded">{safeCompanyData.economicCode || '-'}</div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <label className="form-label fw-bold text-muted fs-12 mb-1">شماره ثبت</label>
                                    <div className="fs-14 fw-bold text-dark p-2 bg-gray-50 rounded">{safeCompanyData.registrationNum || '-'}</div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <label className="form-label fw-bold text-muted fs-12 mb-1">تلفن / همراه</label>
                                    <div className="fs-14 fw-bold text-dark p-2 bg-gray-50 rounded">{safeCompanyData.phoneNum || safeCompanyData.mobileNum || '-'}</div>
                                </div>
                                <div className="col-lg-12">
                                    <label className="form-label fw-bold text-muted fs-12 mb-1">آدرس کامل</label>
                                    <div className="fs-14 fw-bold text-dark p-2 bg-gray-50 rounded">
                                        {safeCompanyData.province || ''}، {safeCompanyData.city || ''}، {safeCompanyData.street || ''}، پلاک: {safeCompanyData.pelak || ''}، کدپستی: {safeCompanyData.postalCode || '-'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-4">
                <ProfileBranches />
            </div>

            <CompanyEditModal
                isVisible={showEditModal}
                onClose={() => setShowEditModal(false)}
                initialData={companyData}
                onSave={handleEditSave}
            />

            <MoadianFilesModal
                isVisible={showMoadianModal}
                onClose={() => setShowMoadianModal(false)}
            />
        </div>
    );
}

export default ProfileCreate;

